import React from 'react'

import HintPopover from "../../../../hint-popover/hint-popover"
import ProjectSession from "../../../../../model2/project/project-session"
import ProjectIconUI5 from "../../../../../gd-components/icons/project/project-icon-ui5";
import {ItemDisplay} from "../../../../../model2/item/@type";

type Props = {
    project                 : ProjectSession
    level?                  : number
    selectedProjects        : ID[]

    colorized?              : boolean
    keyboardHighlighted?    : boolean

    onSelect                : callback
    onMenuItemHandleClick?  : callback
}

type State = {
    useHint: boolean,
    hovered: boolean,
}

// const debug = "ProjectTree_Item"
const debug = false

export default class ProjectTree_Item extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            useHint: false,
            hovered: false
        }
    }

    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()

        if (this.props.project.treeDisplay !== ItemDisplay.VISIBLE) {
            if (this.props.project.treeHasVisibleChildren) {
                this.onArrowClick(e)
            }
            return
        }

        this.props.onSelect(this.props.project.id)
    }

    onArrowClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        this.props.onMenuItemHandleClick?.(this.props.project)
    }

    render() {

        if (!this.props.project) {
            console.error("ERROR #kdjdjh24 - how come no project found - onProjectDelete ?")
            return null
        }

        const project = this.props.project

        debug && console.log(debug, 'render', this.props.project.id)

        // Do not display hidden at all
        if (this.props.project.treeDisplay === ItemDisplay.HIDDEN) {
            return null
        }

        const classes = Classes('item project', 'level-'+this.props.level, 'projectId-'+this.props.project.id /*required for scroll to node*/, {
            'selected'              : this.props.selectedProjects.includes(this.props.project.id),
            'hovered'               : this.state.hovered,
            'keyboard-highlighted'  : this.props.keyboardHighlighted,
            // 'disabled'  : project.treeIsGhost
        })

        const hasVisibleChildren = project.treeHasVisibleChildren

        const arrowClasses = Classes("arrow", {
            "hidden"    : !hasVisibleChildren,
            "closed"    : !this.props.project.treeIsExpandedProjectSelector,
            "open"      : this.props.project.treeIsExpandedProjectSelector
        })

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="row">
                    <div className={arrowClasses} onClick={this.onArrowClick}/>
                    <ProjectIconUI5 className   = "icon"
                                    project     = {this.props.project}
                                    colorize    = {this.props.colorized}
                                    isExpanded  = {hasVisibleChildren && this.props.project.treeIsExpandedProjectSelector}/>
                    <div className="name">{this.props.project.name}</div>
                </div>

                {this.state.useHint &&
                    <HintPopover parent={this} hint={this.props.project.name} multiline={true}/>}
            </div>
        )
    }
}
